import { frameworkSymbol } from "../../../core/components/symbol/configuration/symbolconfiguration";
import { configGame } from "../../../data/config";


frameworkSymbol.data = {
    "SYMBOL_WIDTH": configGame.SYMBOL_WIDTH,
    "SYMBOL_HEIGHT": configGame.SYMBOL_HEIGHT,
    "SINGLE_SYMBOL_DELAY_IN_ANIM": 0,
    "SYMBOL_ANIMATION_GRP_WISE": false,
    "SYMBOL_ANIMATION_EFFECT": [],
    "OVERLAY_SYMBOL_LIST": [],


    "symbols": [
        {
            "id": "0",
            "name": "lv1_sym",
            "width": configGame.SYMBOL_WIDTH,
            "height": configGame.SYMBOL_HEIGHT,
            "anchor": [0, 0],
            "offsetX": 0,
            "offsetY": 0,
            "child": [
                {
                    "image": "lv1_sym",
                    "type": "Image",
                    "width": configGame.SYMBOL_WIDTH,
                    "height": configGame.SYMBOL_HEIGHT,
                    "visible": true,
                    "anchor": [0.5, 0.5],
                    "x": configGame.SYMBOL_WIDTH / 2,
                    "y": configGame.SYMBOL_HEIGHT / 2
                },
            ],
            "visible": true,
        },

        {
            "id": "1",
            "name": "lv2_sym",
            "width": configGame.SYMBOL_WIDTH,
            "height": configGame.SYMBOL_HEIGHT,
            "anchor": [0, 0],
            "offsetX": 0,
            "offsetY": 0,
            "child": [
                {
                    "image": "lv2_sym",
                    "type": "Image",
                    "width": configGame.SYMBOL_WIDTH,
                    "height": configGame.SYMBOL_HEIGHT,
                    "visible": true,
                    "anchor": [0.5, 0.5],
                    "x": configGame.SYMBOL_WIDTH / 2,
                    "y": configGame.SYMBOL_HEIGHT / 2
                },
            ],
            "visible": true,
        },


        {
            "id": "2",
            "name": "lv3_sym",
            "width": configGame.SYMBOL_WIDTH,
            "height": configGame.SYMBOL_HEIGHT,
            "anchor": [0, 0],
            "offsetX": 0,
            "offsetY": 0,
            "child": [
                {
                    "image": "lv3_sym",
                    "type": "Image",
                    "width": configGame.SYMBOL_WIDTH,
                    "height": configGame.SYMBOL_HEIGHT,
                    "visible": true,
                    "anchor": [0.5, 0.5],
                    "x": configGame.SYMBOL_WIDTH / 2,
                    "y": configGame.SYMBOL_HEIGHT / 2
                },
            ],
            "visible": true,
        },

        {
            "id": "3",
            "name": "lv4_sym",
            "width": configGame.SYMBOL_WIDTH,
            "height": configGame.SYMBOL_HEIGHT,
            "anchor": [0, 0],
            "offsetX": 0,
            "offsetY": 0,
            "child": [
                {
                    "image": "lv4_sym",
                    "type": "Image",
                    "width": configGame.SYMBOL_WIDTH,
                    "height": configGame.SYMBOL_HEIGHT,
                    "visible": true,
                    "anchor": [0.5, 0.5],
                    "x": configGame.SYMBOL_WIDTH / 2,
                    "y": configGame.SYMBOL_HEIGHT / 2
                },
            ],
            "visible": true,
        },


        {
            "id": "4",
            "name": "lv5_sym",
            "width": configGame.SYMBOL_WIDTH,
            "height": configGame.SYMBOL_HEIGHT,
            "anchor": [0, 0],
            "offsetX": 0,
            "offsetY": 0,
            "child": [
                {
                    "image": "lv5_sym",
                    "type": "Image",
                    "width": configGame.SYMBOL_WIDTH,
                    "height": configGame.SYMBOL_HEIGHT,
                    "visible": true,
                    "anchor": [0.5, 0.5],
                    "x": configGame.SYMBOL_WIDTH / 2,
                    "y": configGame.SYMBOL_HEIGHT / 2
                },
            ],
            "visible": true,
        },

        {
            "id": "5",
            "name": "hv1_sym",
            "width": configGame.SYMBOL_WIDTH,
            "height": configGame.SYMBOL_HEIGHT,
            "anchor": [0, 0],
            "offsetX": 0,
            "offsetY": 0,
            "child": [
                {
                    "image": "hv1_sym",
                    "type": "Image",
                    "width": configGame.SYMBOL_WIDTH,
                    "height": configGame.SYMBOL_HEIGHT,
                    "visible": true,
                    "anchor": [0.5, 0.5],
                    "x": configGame.SYMBOL_WIDTH / 2,
                    "y": configGame.SYMBOL_HEIGHT / 2
                },
            ],
            "visible": true,
        },


        {
            "id": "6",
            "name": "hv2_sym",
            "width": configGame.SYMBOL_WIDTH,
            "height": configGame.SYMBOL_HEIGHT,
            "anchor": [0, 0],
            "offsetX": 0,
            "offsetY": 0,
            "child": [
                {
                    "image": "hv2_sym",
                    "type": "Image",
                    "width": configGame.SYMBOL_WIDTH,
                    "height": configGame.SYMBOL_HEIGHT,
                    "visible": true,
                    "anchor": [0.5, 0.5],
                    "x": configGame.SYMBOL_WIDTH / 2,
                    "y": configGame.SYMBOL_HEIGHT / 2
                },
            ],
            "visible": true,
        },




        {
            "id": "7",
            "name": "hv3_sym",
            "width": configGame.SYMBOL_WIDTH,
            "height": configGame.SYMBOL_HEIGHT,
            "anchor": [0, 0],
            "offsetX": 0,
            "offsetY": 0,
            "child": [
                {
                    "image": "hv3_sym",
                    "type": "Image",
                    "width": configGame.SYMBOL_WIDTH,
                    "height": configGame.SYMBOL_HEIGHT,
                    "visible": true,
                    "anchor": [0.5, 0.5],
                    "x": configGame.SYMBOL_WIDTH / 2,
                    "y": configGame.SYMBOL_HEIGHT / 2
                },
            ],
            "visible": true,
        },


        {
            "id": "8",
            "name": "hv4_sym",
            "width": configGame.SYMBOL_WIDTH,
            "height": configGame.SYMBOL_HEIGHT,
            "anchor": [0, 0],
            "offsetX": 0,
            "offsetY": 0,
            "child": [
                {
                    "image": "hv4_sym",
                    "type": "Image",
                    "width": configGame.SYMBOL_WIDTH,
                    "height": configGame.SYMBOL_HEIGHT,
                    "visible": true,
                    "anchor": [0.5, 0.5],
                    "x": configGame.SYMBOL_WIDTH / 2,
                    "y": configGame.SYMBOL_HEIGHT / 2
                },
            ],
            "visible": true,
        },


        {
            "id": "9",
            "name": "hv5_sym",
            "width": configGame.SYMBOL_WIDTH,
            "height": configGame.SYMBOL_HEIGHT,
            "anchor": [0, 0],
            "offsetX": 0,
            "offsetY": 0,
            "child": [
                {
                    "image": "hv5_sym",
                    "type": "Image",
                    "width": configGame.SYMBOL_WIDTH,
                    "height": configGame.SYMBOL_HEIGHT,
                    "visible": true,
                    "anchor": [0.5, 0.5],
                    "x": configGame.SYMBOL_WIDTH / 2,
                    "y": configGame.SYMBOL_HEIGHT / 2
                },
            ],
            "visible": true,
        },



        {
            "id": "10",
            "name": "wild1x_sym",
            "width": configGame.SYMBOL_WIDTH,
            "height": configGame.SYMBOL_HEIGHT,
            "anchor": [0, 0],
            "offsetX": 0,
            "offsetY": 0,
            "child": [
                {
                    "image": "wild1x_sym",
                    "type": "Image",
                    "width": configGame.SYMBOL_WIDTH,
                    "height": configGame.SYMBOL_HEIGHT,
                    "visible": true,
                    "anchor": [0.5, 0.5],
                    "x": configGame.SYMBOL_WIDTH / 2,
                    "y": configGame.SYMBOL_HEIGHT / 2
                },
            ],
            "visible": true,
        },


        {
            "id": "11",
            "name": "bonus_sym",
            "width": configGame.SYMBOL_WIDTH,
            "height": configGame.SYMBOL_HEIGHT,
            "anchor": [0, 0],
            "offsetX": 0,
            "offsetY": 0,
            "child": [
                {
                    "image": "bonus_sym",
                    "type": "Image",
                    "width": configGame.SYMBOL_WIDTH,
                    "height": configGame.SYMBOL_HEIGHT,
                    "visible": true,
                    "anchor": [0.5, 0.5],
                    "x": configGame.SYMBOL_WIDTH / 2,
                    "y": configGame.SYMBOL_HEIGHT / 2
                },
            ],
            "visible": true,
        },


        {
            "id": "12",
            "name": "wild2x_sym",
            "width": configGame.SYMBOL_WIDTH,
            "height": configGame.SYMBOL_HEIGHT,
            "anchor": [0, 0],
            "offsetX": 0,
            "offsetY": 0,
            "child": [
                {
                    "image": "wild2x_sym",
                    "type": "Image",
                    "width": configGame.SYMBOL_WIDTH,
                    "height": configGame.SYMBOL_HEIGHT,
                    "visible": true,
                    "anchor": [0.5, 0.5],
                    "x": configGame.SYMBOL_WIDTH / 2,
                    "y": configGame.SYMBOL_HEIGHT / 2
                },
            ],
            "visible": true,
        },
        {
            "id": "13",
            "name": "wild3x_sym",
            "width": configGame.SYMBOL_WIDTH,
            "height": configGame.SYMBOL_HEIGHT,
            "anchor": [0, 0],
            "offsetX": 0,
            "offsetY": 0,
            "child": [
                {
                    "image": "wild3x_sym",
                    "type": "Image",
                    "width": configGame.SYMBOL_WIDTH,
                    "height": configGame.SYMBOL_HEIGHT,
                    "visible": true,
                    "anchor": [0.5, 0.5],
                    "x": configGame.SYMBOL_WIDTH / 2,
                    "y": configGame.SYMBOL_HEIGHT / 2
                },
            ],
            "visible": true,
        },




    ],
    "symbolsAnimation": [
        {
            "id": "0",
            "name": "lv1_sym_anim",
            "width": configGame.SYMBOL_WIDTH,
            "height": configGame.SYMBOL_HEIGHT,
            "offsetX": 0,
            "offsetY": 0,
            "child": [


                {
                    "id": "lv1_Glow_sym_anim",
                    "name": "symbols_blast_anim",
                    "type": "Spine",
                    "width": 201,
                    "height": 311,
                    "image": "symbols_blast_anim",
                    "animationSpeed": 0.2,
                    "playing": false,
                    "loop": false,
                    "visible": true,
                    "effectType": "abc",
                    "maskHeight": 336,
                    "spineAnimName": "sym_lv5",
                    "x": 71,
                    "y": 137,
                    "spinedata": {
                        "spinename": "symbols_blast_anim",
                        "animationname": "sym_lv5",
                        "loop": false,
                        "timeScale": 1

                    },
                },
            ],
            "loop": false,
            "visible": true,
        },
        {
            "id": "1",
            "name": "lv2_sym_anim",
            "width": configGame.SYMBOL_WIDTH,
            "height": configGame.SYMBOL_HEIGHT,
            "offsetX": 0,
            "offsetY": 0,

            "child": [


                {
                    "id": "lv2_Glow_sym_anim",
                    "name": "symbols_blast_anim",
                    "type": "Spine",
                    "width": 402,
                    "height": 622,
                    "image": "symbols_blast_anim",
                    "animationSpeed": 0.2,
                    "playing": false,
                    "loop": false,
                    "visible": true,
                    "effectType": "abc",
                    "maskHeight": 336,
                    "spineAnimName": "sym_lv4",

                    "x": 71,
                    "y": 137,
                    "spinedata": {
                        "spinename": "symbols_blast_anim",
                        "animationname": "sym_lv4",
                        "loop": false,
                        "timeScale": 0.9

                    },
                },


            ],
            "loop": false,
            "visible": true,
        },
        {
            "id": "2",
            "name": "lv3_sym_anim",
            "width": configGame.SYMBOL_WIDTH,
            "height": configGame.SYMBOL_HEIGHT,
            "offsetX": 0,
            "offsetY": 0,

            "child": [


                {
                    "id": "lv3_Glow_sym_anim",
                    "name": "symbols_blast_anim",
                    "type": "Spine",
                    "width": 402,
                    "height": 622,
                    "image": "symbols_blast_anim",
                    "animationSpeed": 0.2,
                    "playing": false,
                    "loop": false,
                    "visible": true,
                    "effectType": "abc",
                    "maskHeight": 336,
                    "spineAnimName": "sym_lv3",

                    "x": 71,
                    "y": 137,
                    "spinedata": {
                        "spinename": "symbols_blast_anim",
                        "animationname": "sym_lv3",
                        "loop": false,
                        "timeScale": 0.9

                    },
                },

            ],
            "loop": false,
            "visible": true,
        },
        {
            "id": "3",
            "name": "lv4_sym_anim",
            "width": configGame.SYMBOL_WIDTH,
            "height": configGame.SYMBOL_HEIGHT,
            "offsetX": 0,
            "offsetY": 0,

            "child": [


                {
                    "id": "lv4_Glow_sym_anim",
                    "name": "symbols_blast_anim",
                    "type": "Spine",
                    "width": 402,
                    "height": 622,
                    "image": "symbols_blast_anim",
                    "animationSpeed": 0.2,
                    "playing": false,
                    "loop": false,
                    "visible": true,
                    "effectType": "abc",
                    "maskHeight": 336,
                    "spineAnimName": "sym_lv2",

                    "x": 71,
                    "y": 137,
                    "spinedata": {
                        "spinename": "symbols_blast_anim",
                        "animationname": "sym_lv2",
                        "loop": false,
                        "timeScale": 0.9

                    },
                },


            ],
            "loop": false,
            "visible": true,
        },
        {
            "id": "4",
            "name": "lv5_sym_anim",
            "width": configGame.SYMBOL_WIDTH,
            "height": configGame.SYMBOL_HEIGHT,
            "offsetX": 0,
            "offsetY": 0,

            "child": [


                {
                    "id": "lv5_Glow_sym_anim",
                    "name": "symbols_blast_anim",
                    "type": "Spine",
                    "width": 402,
                    "height": 622,
                    "image": "symbols_blast_anim",
                    "animationSpeed": 0.2,
                    "playing": false,
                    "loop": false,
                    "visible": true,
                    "effectType": "abc",
                    "maskHeight": 336,
                    "spineAnimName": "sym_lv1",

                    "x": 71,
                    "y": 137,
                    "spinedata": {
                        "spinename": "symbols_blast_anim",
                        "animationname": "sym_lv1",
                        "loop": false,
                        "timeScale": 0.9

                    },
                },

            ],
            "loop": false,
            "visible": true,
        },
        {
            "id": "5",
            "name": "hv1_sym_anim",
            "width": configGame.SYMBOL_WIDTH,
            "height": configGame.SYMBOL_HEIGHT,
            "offsetX": 0,
            "offsetY": 0,

            "child": [



                {
                    "id": "hv1_Glow_sym_anim",
                    "name": "symbols_blast_anim",
                    "type": "Spine",
                    "width": 402,
                    "height": 622,
                    "image": "symbols_blast_anim",
                    "animationSpeed": 0.2,
                    "playing": false,
                    "loop": false,
                    "visible": true,
                    "effectType": "abc",
                    "maskHeight": 336,
                    "spineAnimName": "sym_hv5",

                    "x": 71,
                    "y": 137,
                    "spinedata": {
                        "spinename": "symbols_blast_anim",
                        "animationname": "sym_hv5",
                        "loop": false,
                        "timeScale": 0.9

                    },
                },


            ],
            "loop": false,
            "visible": true,
        },
        {
            "id": "6",
            "name": "hv2_sym_anim",
            "width": configGame.SYMBOL_WIDTH,
            "height": configGame.SYMBOL_HEIGHT,
            "offsetX": 0,
            "offsetY": 0,

            "child": [


                {
                    "id": "hv2_Glow_sym_anim",
                    "name": "symbols_blast_anim",
                    "type": "Spine",
                    "width": 402,
                    "height": 622,
                    "image": "symbols_blast_anim",
                    "animationSpeed": 0.2,
                    "playing": false,
                    "loop": false,
                    "visible": true,
                    "effectType": "abc",
                    "maskHeight": 336,
                    "spineAnimName": "sym_hv4",

                    "x": 71,
                    "y": 137,
                    "spinedata": {
                        "spinename": "symbols_blast_anim",
                        "animationname": "sym_hv4",
                        "loop": false,
                        "timeScale": 0.9

                    },
                },


            ],
            "loop": false,
            "visible": true,
        },
        {
            "id": "7",
            "name": "hv3_sym_anim",
            "width": configGame.SYMBOL_WIDTH,
            "height": configGame.SYMBOL_HEIGHT,
            "offsetX": 0,
            "offsetY": 0,

            "child": [


                {
                    "id": "hv3_Glow_sym_anim",
                    "name": "symbols_blast_anim",
                    "type": "Spine",
                    "width": 402,
                    "height": 622,
                    "image": "symbols_blast_anim",
                    "animationSpeed": 0.2,
                    "playing": false,
                    "loop": false,
                    "visible": true,
                    "effectType": "abc",
                    "maskHeight": 336,
                    "spineAnimName": "sym_hv3",

                    "x": 71,
                    "y": 137,
                    "spinedata": {
                        "spinename": "symbols_blast_anim",
                        "animationname": "sym_hv3",
                        "loop": false,
                        "timeScale": 0.9

                    },
                },


            ],
            "loop": false,
            "visible": true,
        },
        {
            "id": "8",
            "name": "hv4_sym_anim",
            "width": configGame.SYMBOL_WIDTH,
            "height": configGame.SYMBOL_HEIGHT,
            "offsetX": 0,
            "offsetY": 0,

            "child": [


                {
                    "id": "hv4_Glow_sym_anim",
                    "name": "symbols_blast_anim",
                    "type": "Spine",
                    "width": 402,
                    "height": 622,
                    "image": "symbols_blast_anim",
                    "animationSpeed": 0.2,
                    "playing": false,
                    "loop": false,
                    "visible": true,
                    "effectType": "abc",
                    "maskHeight": 336,
                    "spineAnimName": "sym_hv2",

                    "x": 71,
                    "y": 137,
                    "spinedata": {
                        "spinename": "symbols_blast_anim",
                        "animationname": "sym_hv2",
                        "loop": false,
                        "timeScale": 0.9

                    },
                },

            ],
            "loop": false,
            "visible": true,
        },
        {
            "id": "9",
            "name": "hv5_sym_anim",
            "width": configGame.SYMBOL_WIDTH,
            "height": configGame.SYMBOL_HEIGHT,
            "offsetX": 0,
            "offsetY": 0,

            "child": [


                {
                    "id": "hv5_Glow_sym_anim",
                    "name": "symbols_blast_anim",
                    "type": "Spine",
                    "width": 402,
                    "height": 622,
                    "image": "symbols_blast_anim",
                    "animationSpeed": 0.2,
                    "playing": false,
                    "loop": false,
                    "visible": true,
                    "effectType": "abc",
                    "maskHeight": 336,
                    "spineAnimName": "sym_hv1",

                    "x": 71,
                    "y": 137,
                    "spinedata": {
                        "spinename": "symbols_blast_anim",
                        "animationname": "sym_hv1",
                        "loop": false,
                        "timeScale": 0.9

                    },
                },

            ],
            "loop": false,
            "visible": true,
        },

        {
            "id": "10",
            "name": "wildx1_sym_anim",
            "width": configGame.SYMBOL_WIDTH,
            "height": configGame.SYMBOL_HEIGHT,
            "offsetX": 0,
            "offsetY": 0,

            "child": [




                {
                    "id": "wildx1_symGlow_anim",
                    "name": "symbols_blast_anim",
                    "type": "Spine",
                    "width": 356.85,
                    "height": 279,
                    "image": "symbols_blast_anim",
                    "animationSpeed": 0.2,
                    "playing": false,
                    "loop": false,
                    "visible": true,
                    "effectType": "abc",
                    "maskHeight": 336,
                    "spineAnimName": "wild_1X1",

                    "x": 71,
                    "y": 138,
                    "spinedata": {
                        "spinename": "symbols_blast_anim",
                        "animationname": "wild_1X1",
                        "loop": false,
                        "timeScale": 0.9

                    },
                },

            ],
            "loop": false,
            "visible": true,
        },

        {
            "id": "11",
            "name": "bonus_sym_anim",
            "width": configGame.SYMBOL_WIDTH,
            "height": configGame.SYMBOL_HEIGHT,
            "offsetX": 0,
            "offsetY": 0,

            "child": [


                {
                    "id": "bonus_sym_anim",
                    "name": "bonus_sym_anim",
                    "type": "Spine",
                    "width": 376,
                    "height": 477.31,
                    "image": "bonus_sym_anim",
                    "animationSpeed": 0.2,
                    "playing": false,
                    "loop": false,
                    "visible": true,
                    "effectType": "abc",
                    "maskHeight": 336,
                    "spineAnimName": "bonus",

                    "x": 71,
                    "y": 137,
                    "spinedata": {
                        "spinename": "bonus_sym_anim",
                        "animationname": "bonus",
                        "loop": false,
                        "timeScale": 0.9

                    },
                },



            ],
            "loop": false,
            "visible": true,
        },
        {
            "id": "12",
            "name": "wildx2_sym_anim",
            "width": configGame.SYMBOL_WIDTH,
            "height": configGame.SYMBOL_HEIGHT,
            "offsetX": 0,
            "offsetY": 0,

            "child": [


                {
                    "id": "wildx2_symGlow_anim",
                    "name": "symbols_blast_anim",
                    "type": "Spine",
                    "width": 356.85,
                    "height": 279,
                    "image": "symbols_blast_anim",
                    "animationSpeed": 0.2,
                    "playing": false,
                    "loop": false,
                    "visible": true,
                    "effectType": "abc",
                    "maskHeight": 336,
                    "spineAnimName": "wild_1X2",

                    "x": 145,
                    "y": 138,
                    "spinedata": {
                        "spinename": "symbols_blast_anim",
                        "animationname": "wild_1X2",
                        "loop": false,
                        "timeScale": 0.9

                    },
                },
               /*  {
                    "id": "wildx1_symGlow_anim",
                    "name": "symbols_blast_anim",
                    "type": "Spine",
                    "width": 356.85,
                    "height": 279,
                    "image": "symbols_blast_anim",
                    "animationSpeed": 0.2,
                    "playing": false,
                    "loop": false,
                    "visible": true,
                    "effectType": "abc",
                    "maskHeight": 336,
                    "spineAnimName": "wild_1X1",

                    "x": 71,
                    "y": 138,
                    "spinedata": {
                        "spinename": "symbols_blast_anim",
                        "animationname": "wild_1X1",
                        "loop": false,
                        "timeScale": 0.9

                    },
                }, */

            ],
            "loop": false,
            "visible": true,
        },
        {
            "id": "13",
            "name": "wildx3_sym_anim",
            "width": configGame.SYMBOL_WIDTH,
            "height": configGame.SYMBOL_HEIGHT,
            "offsetX": 0,
            "offsetY": 0,

            "child": [


                {
                    "id": "wildx3_symGlow_anim",
                    "name": "symbols_blast_anim",
                    "type": "Spine",
                    "width": 356.85,
                    "height": 279,
                    "image": "symbols_blast_anim",
                    "animationSpeed": 0.2,
                    "playing": false,
                    "loop": false,
                    "visible": true,
                    "effectType": "abc",
                    "maskHeight": 336,
                    "spineAnimName": "wild_1X3",

                    "x": 205,
                    "y": 138,
                    "spinedata": {
                        "spinename": "symbols_blast_anim",
                        "animationname": "wild_1X3",
                        "loop": false,
                        "timeScale": 0.9

                    },
                },


            ],
            "loop": false,
            "visible": true,
        },
    ],

}